export default __webpack_public_path__ + "static/media/source-logo-oohlala.3347cae7.png";